class Modal {
  constructor(openBtnAttr, modalAttr) {
    this.modal = document.querySelector(`[data-modal="${modalAttr}"]`);
    this.openBtn = document.querySelector(`[data-open-modal="${openBtnAttr}"]`);
    this.closeBtns = this.modal.querySelectorAll('[data-close]');
    this.initEventListeners();
  }

  initEventListeners() {
    this.openBtn.addEventListener('click', () => this.openModal());
    this.closeBtns.forEach((button) => {
      button.addEventListener('click', () => this.closeModal());
    });
    window.addEventListener('click', (event) => this.outsideClick(event));
  }

  openModal() {
    this.modal.style.display = 'block';
  }

  closeModal() {
    this.modal.style.display = 'none';
  }

  outsideClick(event) {
    if (event.target === this.modal) {
      this.closeModal();
    }
  }
}

function initModal(openBtnAttr, modalAttr) {
  if (document.querySelector(`[data-modal="${modalAttr}"]`)) {
    new Modal(openBtnAttr, modalAttr);
  }
}

export { initModal };
